import { fmtBRL } from "./format";

export const cashPrice = (p) =>
  p.promo_price && p.promo_price > 0 && p.promo_price < p.price ? p.promo_price : p.price;

export const cardPrice = (p) =>
  p.price_card && p.price_card > 0 ? p.price_card : p.price;

export const maxInstallments = (p) => Math.max(1, Math.min(12, p.max_installments || 12));

/** Divide o total em n parcelas cuja soma é exatamente o total (centavos ajustados na última). */
export function installmentsOf(total, n) {
  const count = Math.max(1, Math.min(12, Math.round(n) || 1));
  const cents = Math.round(total * 100);
  const base = Math.floor(cents / count);
  const parts = Array(count).fill(base);
  parts[count - 1] += cents - base * count;
  return parts.map((c) => c / 100);
}

export const installmentLabel = (p) => {
  const n = maxInstallments(p);
  const card = cardPrice(p);
  return `até ${n}x de ${fmtBRL(installmentsOf(card, n)[0])}`;
};

export const hasCashDiscount = (p) => cashPrice(p) < cardPrice(p);
